// If a blog post's slug is changed in wp-admin after it's already published
// (and possibly indexed/linked/bookmarked), the old URL would otherwise just
// 404 with no way to recover any accumulated search ranking or shared links.
//
// Add an entry here whenever a slug changes: { "old-slug": "new-slug" }.
// BlogDetail redirects old-slug requests to new-slug automatically.
const slugRedirects = {};

export default slugRedirects;
